module.exports = __webpack_public_path__ + "assets/images/shop3.14c2cd6a.jpg";